// eslint-disable-next-line @typescript-eslint/naming-convention
export enum userPermissionsEnum {
    // Implemented services
    accountGhostIn = 1,
    accountManager = 2,
    journodexManager = 3,
    legacyMonitoring = 4,
    advancedMonitoring = 5,
    // @TODO: Uncomment and set the values when NEP-30354 is done: Advanced Monitoring Manager permission
    // is split into Topic Archive Backfills and Mention Renormalization (Bulk Action)
    // topicArchiveBackFills = ,
    // mentionRenormalization = ,
    targeting = 6,
    newsroom = 7,
    engagementStreams = 8,
    distribution = 9,
    newswire = 10,
    mediaSubscriptions = 11,
    journodex = 12,
    account = 13,
    accountsReadOnlyManager = 14,
    advancedTargeting = 17,
    advancedMonitoringManager = 18,
    snapshotPushToMercury = 19,
    wireEditorial = 20,
    advancedMonitoringFullText = 22,
    clientNewsroom = 23,
    newswireplus = 24,
    socialIntelligence = 26,
    openAI = 27,
    copyMentionsToAccount = 28,
    socialSnapshot = 29,
    csvImportToMercury = 30,
    mediaDatabaseApi = 31,
    mediaMonitoringApi = 33, // Media Intelligence
    apiKeyManagement = 34,
    visibilityIntelligence = 35,
    exposedMentionLicenseInfo = 36,
    agenticFeature = 37,
    precisionClipper = 38,

    // This one is front-end only and the number means nothing.
    // it is represented as a boolean in the targeting DB
    influencerStreams = 666
}
